import { NgModule } from '@angular/core';
import { AngularMasonry } from './masonry';
import { AngularMasonryBrick } from './brick';

const DIRECTIVES = [AngularMasonry, AngularMasonryBrick];

@NgModule({
    declarations: DIRECTIVES,
    exports: DIRECTIVES
})
export class MasonryModule { }


// WEBPACK FOOTER //
// /codebuild/output/src3975732384/src/~/angular2-masonry/src/module.ts